module.exports = __webpack_public_path__ + "assets/pdf.64170880b2b4d64a6e486908d41575f7.svg";


//////////////////
// WEBPACK FOOTER
// ./img/pdf.svg
// module id = 919
// module chunks = 0